import { useStyles } from './styles'
import { lang } from '@/shared/constants/lang'
import { $userBalance, $userLanguage, $userToken } from '@/entities/user'
import { useUnit } from 'effector-react'
import { AppButton } from '@/shared/ui/button'
import { FeatureTexts } from '../types'

import { featuresList, subscriptionOptions } from '../constants'
import { getSubscriptionPricesFx } from '@/entities/payments'
import { $selectedSubscriptionOption, $selectedSubscriptionPrice } from '@/entities/payments/store'
import { useEffect, useState } from 'react'
import { Icon } from '../../icon'
import { SubscriptionOption } from '@/features/subscriptionOption'
import { useBuySubscription } from './hooks/useBuySubscription'
import { Discount } from '../../discount'
export const UnsubscribedUserDrawer = ({
  handleHide,
  isOpenedEnough,
}: {
  handleHide?: () => void
  isOpenedEnough?: boolean
}) => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const userBalance = useUnit($userBalance)
  const selectedSubscriptionPrice = useUnit($selectedSubscriptionPrice)
  const selectedSubscriptionOption = useUnit($selectedSubscriptionOption)
  const canAffordDiscount = userBalance > 500000
  const drawerTexts = lang[userLang].pages.main.subscriptionDrawer

  const { handleBuySubscription, isCreating } = useBuySubscription(handleHide)

  useEffect(() => {
    if (userToken) {
      getSubscriptionPricesFx(userToken)
    }
  }, [userToken])

  const [isBtnBlocked, setIsBtnBlocked] = useState(false)
  useEffect(() => {
    if (isOpenedEnough) {
      setTimeout(() => {
        setIsBtnBlocked(false)
      }, 100)
    } else {
      setTimeout(() => {
        setIsBtnBlocked(true)
      }, 100)
    }
  }, [isOpenedEnough])

  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        <div className={classes.logosWrapper}>
          <img
            src="/assets/subscriptionRelated/gamedLogo.webp"
            alt=""
            width={150}
            height={31}
          />
        </div>
        <span>{drawerTexts.description}</span>
      </div>

      <div className={classes.columns}>
        <span className={classes.featureText}>{drawerTexts.columns.feature}</span>
        <div className={classes.columnTitlesWrapper}>
          <Icon
            view="platinum"
            style={{ width: 'fit-content', height: '16px', alignSelf: 'center' }}
          />
          <Icon
            view="plusLogo"
            style={{ width: 'fit-content', height: '16px', alignSelf: 'center' }}
          />
        </div>
      </div>

      <div className={classes.featureList}>
        <div>
          {featuresList.map((feature) => {
            return (
              <div
                key={feature.name}
                className={classes.featureListItem}
              >
                <div className={classes.nameAndLogoWrapper}>
                  <img
                    src={feature.icon}
                    width={'32px'}
                  />
                  <span
                    className={classes.featureName}
                    data-lang={userLang}
                  >
                    {drawerTexts.features[feature.name as keyof FeatureTexts]}
                  </span>
                </div>
                <div className={classes.availabilityWrapper}>
                  {feature.plusValue ? (
                    <>
                      <span className={classes.basicValue}>
                        {feature.platinumValue} {lang[userLang].pages.units.hours}
                      </span>
                      <span className={classes.plusValue}>
                        {feature.plusValue} {lang[userLang].pages.units.hours}
                      </span>
                    </>
                  ) : (
                    <div className={classes.iconsWrapper}>
                      <Icon
                        style={commonIconStyle}
                        view={'checkedWhite'}
                      />
                      <Icon
                        view={feature.plusAvailability ? 'checkedWhite' : 'lock'}
                        style={commonIconStyle}
                      />
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
        <div className={classes.subscriptionOptions}>
          {subscriptionOptions.map((optionVariant) =>
            !canAffordDiscount && optionVariant === 'platinumDiscount' ? null : (
              <SubscriptionOption
                key={optionVariant}
                variant={optionVariant}
              />
            )
          )}
        </div>
      </div>

      <div className={classes.controlsWrapper}>
        <AppButton
          onClick={handleBuySubscription}
          isLoading={isCreating}
          className={classes.button}
          disabled={isBtnBlocked || !isOpenedEnough}
        >
          {drawerTexts.getPlus}
          {selectedSubscriptionPrice} ⭐ {selectedSubscriptionOption == 'platinumDiscount' && <Discount value={30} />}
        </AppButton>
        <span
          className={classes.laterText}
          onClick={handleHide}
        >
          {drawerTexts.later}
        </span>
      </div>
    </div>
  )
}

const commonIconStyle = {
  width: '16px',
  height: '16px',
  aspectRatio: '1/1',
}
